<script setup lang="ts">
const platform = useState('platform')

const links = computed(() => {
  const links = [{
    label: 'Mentions légales',
    to: '/mentions-legales',
  }, {
    label: 'CGU',
    to: '/cgu',
  }, {
    label: 'Politique de protection des données',
    to: '/politique-donnees',
  }]

  if (platform.value.slug === 'croix-rouge') {
    links.push({
      label: 'Paramètres des cookies',
      onClick: () => window.OneTrust?.ToggleInfoDisplay()
    })
  }

  links.push({
    label: 'Espace Asso',
    target: '_blank',
    to: platform.value.dashboard_login_url,
  })

  return links
})

</script>

<template>
  <UPageSection v-if="platform?.settings.prefooter" :title="platform.settings.prefooter.title" class="border-t border-default">
    <template #features>
      <UPageFeature
          v-for="(feature, index) in platform?.settings.prefooter.data"
          :key="index"
          as="li"
      >
        <template #leading>
          <UAvatar size="lg" :text="`${index + 1}`" />
        </template>
        <template #description>
          <Markdown :value="feature.text" unwrap="p"/>
        </template>
      </UPageFeature>
    </template>
  </UPageSection>
  <UFooter :ui="{root: 'bg-[var(--ui-primary)]', left: 'lg:justify-center', right: 'lg:justify-center' }">
    <template #left>
      <a :href="platform?.organization_url" target="_blank">
        <img :src="`https://www.${useBenevoltDomain()}/assets/im/platform/${platform?.slug}-footer.svg`" :alt="platform?.organization_name" class="h-16" />
      </a>
    </template>
    <template #right>
      <a href="https://asso.benevolt.fr" target="_blank" class="flex flex-col gap-1 justify-center items-center h-full">
        <p class="text-white text-sm font-bold">Propulsé par</p>
        <svg class="h-5 text-white" viewBox="0 0 160 28" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Benevolt"><path d="M5.78 25.484v1.06H0V0h6.305v7.444c1.593-1.088 3.486-1.72 5.518-1.72 5.66 0 10.246 4.895 10.246 10.932 0 6.037-4.588 10.93-10.247 10.93-2.26 0-4.35-.78-6.043-2.102zM55.785 7.48V6.433h-6.13v20.233h6.13v-14c.964-1.31 2.848-1.31 3.186-1.31 2.946 0 2.946 2.53 2.946 2.53v12.78h6.13v-12.78s0-8.37-7.253-8.37c-.3 0-3.65 0-5.008 1.962zM150.868 0h6.257v6.913l2.875-.05v4.823h-2.875v15.9h-6.257v-15.9h-2.822V6.863h2.822V0zM138.85 0h6.437v27.586h-6.436V0zm-13.793 27.586c-6.094 0-11.034-4.94-11.034-11.034s4.94-11.035 11.034-11.035c6.095 0 11.035 4.94 11.035 11.035 0 6.094-4.94 11.034-11.035 11.034zm0-6.305c2.612 0 4.73-2.116 4.73-4.728 0-2.612-2.118-4.73-4.73-4.73-2.61 0-4.73 2.118-4.73 4.73 0 2.612 2.12 4.73 4.73 4.73zM92.874 6.438h6.434l4.336 12.103 3.674-12.103h6.705l-7.14 21.15h-6.434l-7.576-21.15zM85.65 26.74c-5.762 2.097-12.134-.874-14.23-6.636-2.098-5.762.34-11.794 6.104-13.892 5.762-2.097 11.67.896 13.77 6.658.25.686.44 1.376.575 2.062.058.3-13.906 4.742-13.804 5.024.836 2.296 3.525 2.585 5.76 1.772.698-.255 3.005-1.91 2.653-2.878l5.646-2.055c.396 6.8-5.593 9.624-6.476 9.945zm-.727-14.365c-.6-1.646-2.976-2.292-5.308-1.443-2.332.848-3.737 2.87-3.138 4.518l8.446-3.075zM35.01 27.585c-6.13 0-11.102-4.94-11.102-11.033 0-6.094 4.97-11.035 11.103-11.035 6.134 0 10.047 4.94 10.047 11.035 0 .725-.055 1.435-.163 2.12-.047.3-14.69-.297-14.69 0 0 2.43 2.43 3.613 4.807 3.613.744 0 3.48-.762 3.48-1.785h6.008c-1.954 6.484-8.547 7.086-9.487 7.086zm4.23-13.66c0-1.742-2.01-3.153-4.493-3.153-2.482 0-4.494 1.41-4.494 3.152h8.988zM11.035 21.86c2.902 0 5.255-2.33 5.255-5.204 0-2.875-2.354-5.205-5.256-5.205S5.78 13.78 5.78 16.657c0 2.874 2.352 5.205 5.254 5.205z" class="fill-current" fill-rule="evenodd"/></svg>
      </a>
    </template>
    <template #default>
      <UNavigationMenu variant="link" :ui="{link: 'text-white hover:text-gray-200', linkLabelExternalIcon: 'text-white hover:text-gray-200', list: 'flex-wrap justify-center'}" :items="links" />
    </template>

  </UFooter>
</template>